import { render, staticRenderFns } from "./ConfirmRequestData.vue?vue&type=template&id=81d33dfe&scoped=true"
import script from "./ConfirmRequestData.vue?vue&type=script&lang=js"
export * from "./ConfirmRequestData.vue?vue&type=script&lang=js"
import style0 from "./ConfirmRequestData.vue?vue&type=style&index=0&id=81d33dfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d33dfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VTextField})
